import { Helmet } from 'react-helmet';

import Layout                               from '../components/Layout.jsx';
import CoverImage                           from '../components/blocks/CoverImage.jsx';
import Block                                from '../components/blocks/Block.jsx';
import Loading                              from '../components/Loading.jsx';
import { colorToTwClass, spacingToTwClass } from '../helpers.js';
import useCustomPageTemplateData            from '../hooks/useCustomPageTemplateData.js';
import KeepExploringDefault                 from '../modules/KeepExploringDefault.jsx';
import Analytics                            from '../components/Analytics.jsx';

const CustomPageTemplate = (props) => {
  const { apikey, page } = props;

  const { data, isLoading, error } = useCustomPageTemplateData(apikey, page);

  if (isLoading) return <Loading/>;
  if (error) return <div>Error...</div>;

  return (
    <>
      {data && <Helmet>
        <title>Rolex</title>
        <meta name="description"
              content={''}/>
        <meta name="keywords" content={``} />
      </Helmet>}
      {/*Todo*/}
      <Analytics pageType="TODO page" />
      <Layout>
        {/*<section>*/}
        {/*  <CoverImage image={data.rlx_watch[0].cover_image[0].rlx_responsive_asset_id}/>*/}
        {/*</section>*/}
        {/*{data.rlx_watch[0].sections.map(section => {*/}
        {/*  return (*/}
        {/*    <section*/}
        {/*      class={spacingToTwClass(section.rlx_section_id.spacing) + ' ' + colorToTwClass(section.rlx_section_id.background_color)}>*/}
        {/*      {section.rlx_section_id.blocks.map(block => {*/}
        {/*        return (*/}
        {/*          <div class={spacingToTwClass(block.spacing)}>*/}
        {/*            <Block block={block}/>*/}
        {/*          </div>*/}
        {/*        )*/}
        {/*      })}*/}
        {/*    </section>*/}
        {/*  )*/}
        {/*})}*/}
        <section class="py-[8vh] bg-white">
          <KeepExploringDefault/>
        </section>
      </Layout>
    </>
  )
};

export default CustomPageTemplate
